import React from 'react';
import ClassNames from "../ClassNames";

import styles from './Wrapper.module.scss';

interface Props {
    children: React.ReactNode;
    center?: boolean;
    style?: React.CSSProperties;
}

export function Wrapper({children, center, style}: Props) {
    return (
        <div
            className={ClassNames(styles.Wrapper, center && styles.center)}
            style={style}
        >
            {children}
        </div>
    );
}
